<p-toast></p-toast>
<ami-dialog-message [setting]="message"></ami-dialog-message>

<ami-table-expansion
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
  [childSettings]="tableChild.settings"
  [childActions]="tableChild.actions"
  (childAction)="onReciveActionChild($event)"
>
</ami-table-expansion>

<pg-stock-price-sidebar
  *ngIf="sidebar.price.open"
  (close)="onCloseSideBarPrice()"
  [item]="sidebar.price.data"
></pg-stock-price-sidebar>

<pg-stock-quantity-sidebar
  *ngIf="sidebar.quantity.open"
  (close)="onCloseSideBarQuantity()"
  [item]="sidebar.quantity.data"
></pg-stock-quantity-sidebar>

<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>

<p-dialog
  header="Conflicto en Abrir presentacion de venta"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '17vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <p class="m-0">No existe Subformato y/o No hay stock</p>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (click)="displayModal = false"
      label="Ok"
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>
